import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-offices',
  templateUrl: './admin-offices.component.html',
  styleUrls: ['./admin-offices.component.css']
})
export class AdminOfficesComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  offices: any[] = [];
  cols: any[];
  roles: SelectItem[] = [];
  types: SelectItem[] = [];
  display = false;
  displayaddoffice = false;
  colors: SelectItem[];
  formdata;
value: boolean | null = null;
  result = '';
  subscriptions: Subscription[] = [];
isactivelist: SelectItem[] = [{ label: 'Visa alla', value: '' }, { label: 'Ja', value: true }, { label: 'Nej', value: false }];

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'officeTypeSort', header: 'Sortering' },
      { field: 'officeTypeAbbreviation', header: 'Förkortning' },
      { field: 'officeTypeName', header: 'Namn' },
      { field: 'abbreviation', header: 'Förkortning' },
      { field: 'name', header: 'Namn' },
      { field: 'email', header: 'Epost' },
      { field: 'sort', header: 'Sortering' },
      { field: 'isActive', header: 'Aktiv' },
      { field: 'roleDescription', header: 'Behörighetsroll' },
    ];

    this.colors = [
      { label: 'White', value: 'White' },
      { label: 'Green', value: 'Green' },
      { label: 'Silver', value: 'Silver' },
      { label: 'Black', value: 'Black' },
      { label: 'Red', value: 'Red' },
      { label: 'Maroon', value: 'Maroon' },
      { label: 'Brown', value: 'Brown' },
      { label: 'Orange', value: 'Orange' },
      { label: 'Blue', value: 'Blue' }
    ];
    this.getRoles();
  }

  test(e) {
    console.log(e);
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera valt uppdrag?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteOffice(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteOffice(rowdata) {
    this.adminService.RemoveOffice(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Uppdrag raderat.' });
        this.getOffices();
      }
    });
  }

  getOffices() {
    this.adminService.GetOffices().subscribe(data => {
      if (data) {
        this.offices = data;
      }
    });
  }

  getRoles() {
    this.adminService.GetRoles().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.description, value: d.id
          };
          this.roles.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.roles.unshift(emptyrecord);
        this.getOfficeTypes();
      }
    });
  }

  getOfficeTypes() {
    this.adminService.GetOfficeTypes().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.types.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.types.unshift(emptyrecord);
        this.getOffices();
      }
    });
  }

  saveOffice(evt) {
    this.adminService.UpdateOffice(evt).subscribe(x => {
      if (x) {
        this.display = false;
        this.getOffices();
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Uppdraget uppdaterat' });
      }
    });

  }

  cancelEdit() {
    this.display = false;
  }

  addOffice() {
    this.displayaddoffice = true;
  }

  saveAddOffice(evt) {
    this.adminService.AddOffice(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Uppdraget tillagt' });
        this.getOffices();
      }
    });
    this.displayaddoffice = false;
  }

  cancelAdd() {
    this.displayaddoffice = false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    let firstrow = 'Ämbetstyp Sortering;Ämbetstyp Förkortning;Ämbetstyp Namn;Ämbete Förkortning;Ämbete Namn;Ämbete Epost;Ämbete Sortering;Ämbete Aktiv;Behörighetsroll';
    const filnamn = 'OF_offices';
    const excelrecords: any[] = [];
    this.offices.forEach(r => {
      const row = {
        officeTypeSort: r.officeTypeSort,
        officeTypeAbbreviation: r.officeTypeAbbreviation,
        officeTypeName: r.officeTypeName,
        abbreviation: r.abbreviation,
        name: r.name,
        email: r.email,
        sort: r.sort,
        isActive: r.isActive,
        roleDescription: r.roleDescription
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }

  cycleTriState() {
  if (this.value === null) {
    this.value = true;
  } else if (this.value === true) {
    this.value = false;
  } else {
    this.value = null;
  }
}
}
